export const requestData = ( url, callback, userChanged ) => {
	fetch( url, {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		body: `user_changed=${userChanged}`,
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		referrerPolicy: 'no-referrer'
	} )
		.then( response => response.json() )
		.then( callback );
};
